import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function ArticleSection() {
  const latestArticles = articles.slice(0, 4);

  return (
    <section className="py-12 md:py-16 bg-background-100 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900">
              影视资讯
            </h2>
            <p className="text-sm text-foreground-500 mt-1">最新影评、资讯和观影指南</p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {latestArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="aspect-[16/9] overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4">
                <div className="flex items-center gap-2 mb-2">
                  <span className="px-2 py-0.5 rounded-md bg-accent-100 text-accent-700 text-xs font-medium whitespace-nowrap">
                    {article.category}
                  </span>
                  <span className="text-xs text-foreground-500">{article.date}</span>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 leading-relaxed mb-2">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-500 line-clamp-2 leading-relaxed">
                  {article.summary}
                </p>
                <div className="flex items-center gap-3 mt-3 pt-3 border-t border-background-200">
                  <span className="text-xs text-foreground-600">
                    <i className="ri-user-line mr-1"></i>{article.author}
                  </span>
                  <span className="text-xs text-foreground-500">
                    <i className="ri-eye-line mr-1"></i>{article.readCount.toLocaleString()}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}